import React from 'react'
import { Col, Form, Row, Select } from 'antd'
const normalize = (s = '') =>
  String(s).toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '').trim()

const makeFilterOption = () => (input, option) => {
  const q = normalize(input)
  const label = normalize(option?.label ?? '')
  const value = normalize(option?.value ?? '')
  // cari di label atau value (kalau value berupa kode)
  return label.includes(q) || value.includes(q)
}

const commonSearchProps = {
  showSearch: true,
  optionFilterProp: 'label',
  filterOption: makeFilterOption(),
  // opsional: urutkan hasil yang cocok di depan
  filterSort: (a, b) =>
    String(a.label).localeCompare(String(b.label), undefined, { sensitivity: 'base' })
}

export default function WbsFilterForm({
  form,
  filters,
  setFilters,
  orgOptions,
  divOptions,
  deptOptions,
  posOptions,            // ✅
  setDivOptions,
  setDeptOptions,
  setPosOptions,         // ✅
  isLoadingOrgList,
  isLoadingDivList,
  isLoadingDeptList,
  isLoadingPosList,      // ✅
  fetchDataDivision,
  fetchDataDepartment,
  fetchDataPosition,      // ✅
  wfOptions,                // ✅
  setWfOptions,             // ✅
  isLoadingWfList,          // ✅
  fetchDataWorkflow         // ✅
}) {
  return (
    <Form layout="horizontal" form={form}>
      <Row gutter={16}>
        <Col xs={24} sm={8} md={6}>
          <Form.Item name="orgId">
            <Select
              style={{ width: '100%' }}
              allowClear
              showSearch
              placeholder="Select Organization"
              loading={isLoadingOrgList}
              options={orgOptions}
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
              onChange={(value) => {
                setFilters((prev) => ({
                  ...prev,
                  orgId: value || null,
                  divId: null,
                  deptId: null,
                  posId: null,
                }));
                form.setFieldsValue({ divId: undefined, deptId: undefined, posId: undefined });
                if (value) fetchDataDivision(value);
                else setDivOptions([]);
              }}
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={8} md={4}>
          <Form.Item name="divId">
            <Select
              style={{ width: '100%' }}
              allowClear
              showSearch
              placeholder="Select Division"
              loading={isLoadingDivList}
              disabled={!filters?.orgId}
              options={divOptions}
              {...commonSearchProps}
              onChange={(value) => {
                setFilters((prev) => ({
                  ...prev,
                  divId: value || null,
                  deptId: null, // reset dept saat division berubah
                }));
                form.setFieldsValue({ deptId: undefined });
                if (value) fetchDataDepartment(value);
                else setDeptOptions([]);
              }}

            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={8} md={4}>
          <Form.Item name="deptId">
            <Select
              style={{ width: '100%' }}
              allowClear
              showSearch
              placeholder="Select Department"
              loading={isLoadingDeptList}
              disabled={!filters?.divId}
              options={deptOptions}
              {...commonSearchProps}
              onChange={(value) => {
                setFilters((prev) => ({
                  ...prev,
                  deptId: value || null,
                  posId: null
                }));
                form.setFieldsValue({ posId: undefined });
                if (value) fetchDataPosition(value);
                else setPosOptions([]);
              }}
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={8} md={4}>
          <Form.Item name="posId">
            <Select
              style={{ width: '100%' }}
              allowClear
              placeholder="Select Position"
              loading={isLoadingPosList}
              disabled={!filters?.deptId}
              options={posOptions}
              {...commonSearchProps}
              onChange={(value) => {
                setFilters((prev) => ({
                  ...prev,
                  posId: value || null
                }));
              }}
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={8} md={6}>
          <Form.Item name="wfId">
            <Select
              style={{ width: '100%' }}
              allowClear
              placeholder="Select Workflow Status"
              loading={isLoadingWfList}
              options={wfOptions}
               {...commonSearchProps}
              onChange={(value) => {
                setFilters((prev) => ({
                  ...prev,
                  wfId: value || null
                }));
              }}
            />
          </Form.Item>
        </Col>



      </Row>
    </Form>
  );
}
